<div class="flex--column spacing--margin-bottom">
  <mat-label class="text--bold text--small">
    {{ 'wdo-labels.' + settingName | translate }}
  </mat-label>
  <mat-radio-group (change)="setValue($event)">
    <mat-radio-button
      class="text--small"
      [attr.data-test]="'wdo-setting-option__' + settingName + '-off'"
      color="primary"
      [value]="'Off'"
      [checked]="value === 'Off'"
      [disabled]="isDisabled"
    >
      {{ 'wdo-settings.setting-option.off' | translate }}
    </mat-radio-button>
    <mat-radio-button
      class="text--small"
      [attr.data-test]="'wdo-setting-option__' + settingName + '-per-day'"
      color="primary"
      [value]="'PerDay'"
      [checked]="value === 'PerDay'"
      [disabled]="isDisabled"
    >
      {{ 'wdo-settings.setting-option.per-day' | translate }}
    </mat-radio-button>
    <mat-radio-button
      class="text--small"
      [attr.data-test]="'wdo-setting-option__' + settingName + '-per-week'"
      color="primary"
      [value]="'PerWeek'"
      [checked]="value === 'PerWeek'"
      [disabled]="isDisabled"
    >
      {{ 'wdo-settings.setting-option.per-week' | translate }}
    </mat-radio-button>
  </mat-radio-group>
</div>
